import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

import { ApBaseControlValueAccessor } from '../base-control/index';

const brRegex = /<\s*br\s*\/?>/gm;

// This is supposed to be a direct port of core-ui/directives/inputs/contenteditable.js
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'div[contenteditable]',
})
export class ContentEditableDirective extends ApBaseControlValueAccessor<string | null> {
  constructor(
    private renderer: Renderer2,
    private element: ElementRef,
  ) {
    super();
  }

  @HostListener('input', ['$event.target.value'])
  onInput(_value: any) {
    const nativeElement = this.element.nativeElement as HTMLDivElement;
    const viewValue = nativeElement.outerText || '';
    let newValue = viewValue;

    if (this.containsBreaks(newValue)) {
      newValue = this.removeBreaks(newValue);
    }

    newValue = this.replaceNbsp(newValue);
    this.propagateChangesFromView(newValue);
  }

  private containsBreaks(str: string): boolean {
    return brRegex.test(String(str));
  }

  private removeBreaks(str: string): string {
    const newstr = String(str).replace(brRegex, ' ');
    return newstr;
  }

  private replaceNbsp(str: string) {
    // instructions currently written in <div> for easy resizing
    // multiple spaces ' ', results in &nbsp; throwing off char count
    if (!str) return str;
    // var re = new RegExp(String.fromCharCode(160), 'g');
    // return str.replace(re, ' ');
    return str.replace(/&nbsp;/g, ' ');
  }

  protected override tryAssignValueProgrammatically(newValue: string | null): void {
    const element = this.element.nativeElement as HTMLDivElement;
    this.renderer.setProperty(element, 'innerHTML', newValue || '');
  }
}
